export default __webpack_public_path__ + "static/media/i209vk.b1a06f4e.webp";